import { CircularProgress, Typography } from '@mui/material';
import localize from '../../common/localize';
import { getStoredCustomLogo } from '../../common/utils';
import ApplicationLogoVertical from './ApplicationLogoVertical';

export default function LoadingPanel({
  text,
  hideCircularProgress,
  donotUseHscreen,
}) {
  const customLogo = getStoredCustomLogo();
  return (
    <div
      className={`flex flex-col items-center justify-center ${
        donotUseHscreen ? '' : 'h-screen'
      }`}
    >
      <ApplicationLogoVertical
        height={120}
        width={120}
        path={customLogo ?? undefined}
      />
      <div
        className="flex text-center font-semibold text-2xl"
        style={{ marginTop: '10px', gap: '10px' }}
      >
        {!hideCircularProgress && (
          <CircularProgress size={20} sx={{ marginRight: 2 }} />
        )}
        <Typography style={{ fontSize: '16px', color: 'gray' }}>{`${
          text ?? localize.loading
        }...`}</Typography>
      </div>
    </div>
  );
}
